<template>
  <div>
    <p v-if="(compareVersionV(version, 'v2.9') == -1) && (status != 3)" class="Not-Online">{{
      $t('lang.particulars.Devicenotonline') }}</p>
    <p v-if="status == 3 || (compareVersionV(version, 'v2.9') != -1)" class="Update-Time">{{
      $t('lang.particulars.ProcessDate') }}:{{
        UpdateTime }}
    </p>
    <el-table :data="ProcessList" size="mini" :header-cell-style="{ background: '#e4f1ff' }" border
      v-if="status == 3 || (compareVersionV(version, 'v2.9') != -1)" :empty-text="emptyText">
      <el-table-column :label="$t('lang.particulars.Processname')" align="center">
        <template slot-scope="scope">
          <el-tooltip placement="top" :content="scope.row.process" effect="dark">
            <span style="cursor: pointer" class="table-text">{{ $t(`lang.particulars.${scope.row.process}`) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.particulars.Processstatus')" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">
            <span class="badge-status-badge-status"></span>
            <span class="table-text">{{ $t('lang.particulars.Running') }}</span>
          </div>
          <div v-if="scope.row.status == 0">
            <span class="badge-status-badge-error"></span>
            <span class="table-text" v-if="scope.row.status != -1">{{ $t('lang.particulars.Stop') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.particulars.Processcontrol')" align="center">
        <template slot-scope="scope">
          <div>
            <el-button type="success" size="mini" :disabled="scope.row.status == 1 || scope.row.status == -1"
              v-if="Permission" @click="Start(scope.$index)">
              {{ $t('lang.particulars.startup') }}
            </el-button>
            <el-button type="warning" size="mini" :disabled="scope.row.status == -1" v-if="Permission"
              @click="Restart(scope.$index)">
              {{ $t('lang.particulars.Restart') }}
            </el-button>
            <el-button type="danger" size="mini"
              :disabled="scope.row.process == 'M2MProxy' || scope.row.process == 'smartm2m' || scope.row.process == 'm2mMqtt' || scope.row.status == 0 || scope.row.status == -1"
              v-if="Permission" @click="Stop(scope.$index)">
              {{ $t('lang.particulars.Stop') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getProgressStatus, progressControl } from '@/api/particulars'
import { compareVersion } from "@/utils/Date";
export default {
  props: ['did', 'SN', 'status', 'Permission', 'version'],
  data() {
    return {
      ProcessList: [],
      GetProcessTime: null,
      //普通服务（/etc/init.d/下的服务名）
      process: ["dropbear", "smartlink", "uhttpd", "loc", "watchcat", 'ss-redir',
        "configmgr", "m2mMqtt", "watchfox", "firewall", "M2MProxy", "mwan3",
        "ipsec", "socat", "openvpn", "smartant", "smartm2m", "smartcat", "frpc"
      ],
      //各vpn网络接口
      network: [
        "pptp1", "eoip", "gre1", "wlan0", 'l2tp1'
      ],
      UpdateTime: null,
      current: '',
      emptyText: this.$t('lang.TableComponent.empty'), //表格数据为空时显示的信息
    }
  },
  watch: {
    SN: {
      immediate: true,
      handler() {
        console.log(this.SN);

        if ((this.current != '') && (this.current != this.did)) {
          this.ProcessList = []
          this.current = this.did
          this.GetProgressStatus()
          //20秒获取一次进程状态
          this.GetProcessTime = setInterval(() => {
            this.GetProgressStatus()
          }, 20000)
          this.ProcessList = []
        } else if (this.current === '') {
          this.current = this.did
          this.GetProgressStatus()
          //20秒获取一次进程状态
          this.GetProcessTime = setInterval(() => {
            this.GetProgressStatus()
          }, 20000)
        }
      }
    }
  },
  mounted() {
    // this.GetProgressStatus()
    // //20秒获取一次进程状态
    // this.GetProcessTime = setInterval(() => {
    //   this.GetProgressStatus()
    // }, 20000)
  },
  methods: {
    compareVersionV(v1, v2){
      return compareVersion(v1, v2)
    },
    //获取进程状态
    GetProgressStatus() {
      this.emptyText = this.$t('lang.TableComponent.loading')
      //如果设备不在线停止获取进程状态，并且清空定时器
      if ((compareVersion(this.version, 'v2.9') == -1) && (this.status != 3)) {
        window.clearInterval(this.GetProcessTime);
        return
      }
      getProgressStatus(this.did, this.SN, { process: this.process, network: this.network }).then((res) => {
        this.ProcessList = []
        let date = new Date()
        this.UpdateTime = date.toLocaleString(this.$i18n.locale == 'zh-CN' ? 'zh' : 'en')
        if (res.data.data.mess === null) {
          window.clearInterval(this.GetProcessTime);
          this.emptyText = this.$t('lang.TableComponent.empty')
          return
        }
        if (res.data.data.mess.length == 0) {
          this.emptyText = this.$t('lang.TableComponent.empty')
        }
        res.data.data.mess.forEach((val, index) => {
          if (val.status !== -1) {
            this.ProcessList.push(val)
          }
        })
        if (this.ProcessList.length === 0) {
          this.emptyText = this.$t('lang.TableComponent.empty')
        }
      }).catch(err => {
        this.emptyText = this.$t('lang.TableComponent.loadingFail')
      })
    },
    //停止进程
    Stop(index) {
      //判断是 普通服务还是各vpn网络接口
      let type, process
      if (this.process.includes(this.ProcessList[index].process)) { type = 0 }
      else if (this.network.includes(this.ProcessList[index].process)) { type = 1 }
      //获取进程名称
      if (this.ProcessList[index].process == 'ss-redir') { process = 'mptcp' }
      else if (this.ProcessList[index].process == 'M2MProxy') { process = 'm2m' }
      else if (this.ProcessList[index].process == 'wlan0') { process = 'wifi' }
      else { process = this.ProcessList[index].process }
      progressControl([{ process, action: 'stop', type }], this.did, this.SN)
        .then((res) => {
          if (res.data.data.mess == 0) {
            this.$message({
              showClose: true,
              message: this.$t('lang.particulars.operation'),
              type: 'success'
            });
            this.GetProgressStatus()
          } else {
            this.$message({
              showClose: true,
              message: this.$t('lang.particulars.BoxapiJSONOperation'),
              type: 'warning'
            });
          }
        })
    },
    //重启进程
    Restart(index) {
      //判断是 普通服务还是各vpn网络接口
      let type, process
      if (this.process.includes(this.ProcessList[index].process)) { type = 0 }
      else if (this.network.includes(this.ProcessList[index].process)) { type = 1 }
      //获取进程名称
      if (this.ProcessList[index].process == 'ss-redir') { process = 'mptcp' }
      else if (this.ProcessList[index].process == 'M2MProxy') { process = 'm2m' }
      else if (this.ProcessList[index].process == 'wlan0') { process = 'wifi' }
      else { process = this.ProcessList[index].process }
      progressControl([{ process, action: 'restart', type }], this.did, this.SN)
        .then((res) => {
          if (res.data.data.mess == 0) {
            this.$message({
              showClose: true,
              message: this.$t('lang.particulars.operation'),
              type: 'success'
            });
            this.GetProgressStatus()
          } else {
            this.$message({
              showClose: true,
              message: this.$t('lang.particulars.BoxapiJSONOperation'),
              type: 'warning'
            });
          }
        })
    },
    //启动进程
    Start(index) {
      //判断是 普通服务还是各vpn网络接口
      let type, process
      if (this.process.includes(this.ProcessList[index].process)) { type = 0 }
      else if (this.network.includes(this.ProcessList[index].process)) { type = 1 }
      //获取进程名称
      if (this.ProcessList[index].process == 'ss-redir') { process = 'mptcp' }
      else if (this.ProcessList[index].process == 'M2MProxy') { process = 'm2m' }
      else if (this.ProcessList[index].process == 'wlan0') { process = 'wifi' }
      else { process = this.ProcessList[index].process }
      progressControl([{ process, action: 'start', type }], this.did, this.SN)
        .then((res) => {
          if (res.data.data.mess == 0) {
            this.$message({
              showClose: true,
              message: this.$t('lang.particulars.operation'),
              type: 'success'
            });
            this.GetProgressStatus()
          } else {
            this.$message({
              showClose: true,
              message: this.$t('lang.particulars.BoxapiJSONOperation'),
              type: 'warning'
            })
          }
        })
    }
  },
  beforeDestroy() {
    window.clearInterval(this.GetProcessTime);
  },
  deactivated() {
    window.clearInterval(this.GetProcessTime);
  }
};
</script>
<style scoped>
.badge-status-badge-status {
  width: 10px;
  height: 10px;
  background-color: #67c23a;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}

.badge-status-badge-warning {
  width: 10px;
  height: 10px;
  background-color: #e6a23c;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}

.badge-status-badge-error {
  width: 10px;
  height: 10px;
  background-color: #f56c6c;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}

.table-text {
  padding-left: 10px;
  font-size: 0.25rem;
}

.Button-Con {
  overflow: hidden;
  width: 220px;
  margin: 0 auto;
}

.Button-List {
  float: left;
}

.Update-Time {
  margin: 10px 20px 10px 0px;
  text-align: right;
  color: #777777;
  font-size: 14px;
}

.Not-Online {
  text-align: center;
  margin: 10px;
  font-size: 15px;
  color: #f56c6c;
  font-weight: 700;
}
</style>
